import './resizable-drawer.css';
import { Button, Drawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getStored, setStored } from '@extensions/utils';

const MIN_WIDTH = 480;

// Правый Drawer с изменяемой шириной (тянуть за левую грань). storageKey — где запоминать ширину
const ResizableDrawer = ({ storageKey, defaultWidth = 900, children, ...props }) => {
    const [width, setWidth] = useState(() => getStored(storageKey, defaultWidth));
    const dragging = useRef(false);

    const onMouseMove = useCallback((e) => {
        if (!dragging.current) return;
        const max = window.innerWidth - 80;
        setWidth(Math.min(max, Math.max(MIN_WIDTH, window.innerWidth - e.clientX)));
    }, []);

    const onMouseUp = useCallback(() => {
        if (!dragging.current) return;
        dragging.current = false;
        document.body.classList.remove('resizable-drawer-dragging');
        setWidth((w) => { setStored(storageKey, w); return w; });
    }, [storageKey]);

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, [onMouseMove, onMouseUp]);

    const onMouseDown = (e) => {
        e.preventDefault();
        dragging.current = true;
        document.body.classList.add('resizable-drawer-dragging');
    };

    return (
        <Drawer
            placement="right"
            width={Math.min(width, window.innerWidth)}
            className="resizable-drawer"
            closeIcon={null}
            extra={<Button type="text" size="small" icon={<CloseOutlined />} onClick={props.onClose} />}
            {...props}
        >
            <div
                className="resizable-drawer-handle"
                role="separator"
                aria-orientation="vertical"
                aria-label="Изменить ширину"
                onMouseDown={onMouseDown}
            />
            {children}
        </Drawer>
    );
};

export default ResizableDrawer;
